import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import MortgageGlossary from "@/pages/MortgageGlossary";

export const Route = createFileRoute("/mortgage-glossary")({
  head: () => seoHead("/mortgage-glossary"),
  component: MortgageGlossary,
});
